import { FormControl } from '@mui/material';
import Grid from '@mui/material/Grid2';
import { DatePicker } from '@mui/x-date-pickers';
import dayjs from 'dayjs';
import { useFormContext } from '../../contexts/FormContext';
import ChartHelpTooltip from '../common/ChartHelpTooltip';
import { Fragment } from 'react';

const DateField = ({ field }: { field: any }) => {
  const { formData, getFormDataItem, handleChange } = useFormContext();

  const label = field.hasOwnProperty('help') ? (
    <Fragment>
      {field.label}
      <ChartHelpTooltip chartType={field.help} type="label" />
    </Fragment>
  ) : (
    field.label
  );

  return (
    <Grid size={field.size || 12} key={field.name}>
      <FormControl required={field.required || false} sx={{ width: '100%', pt: 0 }}>
        <DatePicker
          label={label}
          name={field.name}
          value={getFormDataItem(formData, field.name) ? dayjs(getFormDataItem(formData, field.name)) : null}
          format={field.format || 'DD/MM'}
          onChange={(e) => {
            handleChange(
              {
                target: {
                  name: field.name,
                  value: dayjs(e).startOf('date').valueOf(),
                },
              },
              field,
            );
          }}
          disabled={field.hasOwnProperty('disabled') ? getFormDataItem(formData, field?.disabled) : false}
          shouldDisableDate={(date) => {
            // Disable the 29/2 if the year is not a leap year
            return date.date() === 29 && date.month() === 1;
          }}
        />
      </FormControl>
    </Grid>
  );
};

export default DateField;
